/*eslint-disable*/
/* eslint complexity: off */
/* eslint no-case-declarations: off */
import store from "../store";
import * as defaultActionCreators from "../store/actionCreators/default";
import * as fetchApiActionCreators from "../store/actionCreators/fetchApi";

const ApiBase = {
  DIRECT: "/api/detail/direct/v1",
  DIRECT2: "/api/direct/v1",
  BRIDGE: "bridgeapi",
  DETAIL: "detailapi",
  DELIVERY: "deliveryapi",
  DIBS: "dibsapi",
  DEALSVC: "dealsvcapi",
  ORDER: "orderapi",
  COUPON: "couponapi",
  BOARD: "boardapi",
  BANNER: "bannerapi",
  DEAL_INFO: "dealinfoapi",
  PERSON: "personapi",
  STASH: "stashapi",
  PLAN: "planapi",
  PAY: "payapi",
  MEMBER: "memberapi",
  SEARCH2: "searchapi2",
  SUBS: "subsapi",
};

/**
 * @export
 * @class Api
 * App 내의 Api 요청 값과 요청 부분을 관리
 */
export default class Api {
  /**
   * api의 호출 정보를 반환
   * @param sApiName 정보를 가져올 api명
   * @param htParams 호출할 api에 추가할 파라미터 정보
   * @returns {object} api의 호출 정보
   *  {{
   *      {booolean} needLogin api의 로그인 필요 어부
   *      {object} callParam 호출에 대한 정보 객체
   *          {{
   *             {object} method 송신할 ajax의 HTTP method
   *             {string} contentType 보내는 값을 받는 쪽에서 어떻게 인식할지. 필요에 따라 추가
   *             {string} url 송신할 ajax의 url
   *             {string} data POST parameter (POST 일 떄 api에서 받을 data)
   *             {object} params url에 추가할 GET parameter (HTTP method 관계 없음)
   *             {string} dataType JSONP일 때
   *          }}
   *  }}
   */
  getApiInfo(sApiName, htParams = {}) {
    const htStorage = TMON.oApp.getStorage();
    const htHash = TMON.util.getHashJSON();
    const partnerNo = htStorage.htStaticData.htDealInfo.partnerNo;
    const dealNo = htStorage.htStaticData.sDealNo;
    let params;

    switch (sApiName) {
      // 딜 - 사용자 관련 API
      // 별점, 구매리뷰 노출 여부
      // reviewType: 응답으로 오는 값이며, 다음과 같은 종류가 있음 - A(리뷰·별점 노출), S(별점 노출), N(둘 다 노출하지 않음)
      case "reviewType":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${
              ApiBase.BOARD
            }/api/review/getReviewType/${this.getPlatformText(
              "CAT_PC",
              "CAT_MOBILE",
              "CAT_MOBILE"
            )}/${TMON.oApp.oUtil.getMainCategoryNo()}`, // path param: 플랫폼 - CAT_PC, CAT_MOBILE
          },
        };
      // 옵션 목록, 옵션 정보
      case "optionTree":
        const isCalendar = !isNaN(
          parseInt(htStorage.htStaticData.htDealInfo.calenderInfo, 10)
        );
        params = {
          depth: (htParams && htParams.depth) || "",
          parentKey: (htParams && htParams.parentKey) || "",
          optDealSrl: (htParams && htParams.optDealSrl) || "",
          categoryNo: htStorage.htStaticData.htCategoryInfo.sDepth1No,
          calendar: isCalendar,
        };

        return {
          callParam: {
            method: "GET",
            url: `/api/deals/option/tree/${
              htStorage.htStaticData.sDealNo
            }/depth`,
            data: params,
          },
        };
      case "splitContent":
        params = {
          dealNo: htStorage.htStaticData.sDealNo,
          platformType: this.getPlatformText(
            "PC_WEB",
            "MOBILE_WEB",
            "",
            "ANDROID",
            "IOS"
          ), // 플랫폼 - ANDROID(기본값), IOS, PC_WEB, MOBILE_WEB
        };

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.DEAL_INFO}/api/deals/${
              htStorage.htStaticData.sDealNo
            }/splitContent`,
            data: params,
          },
        };
      case "storeInfo":
        if (TMON.htStaticData.htUseApi.bUseCoupon === false) {
          return null;
        }

        params = {
          partnerNo: htStorage.htStaticData.htDealInfo.partnerNo,
        };

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.PLAN}/api/store/ui/store-info`,
            data: params,
          },
        };
      // 구매혜택 관련 API
      // 카드 이벤트
      case "cardDiscount":
        params = {
          useCache: "CACHE_S10",
          dealSrls: htStorage.htStaticData.sDealNo,
          caller: "Deal",
          platform: TMON.bMobile ? "Mobile" : "PC",
        };

        if (TMON.bLogin) {
          params.useParam = "AS";
        }

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.PAY
            }/api/payment/benefit/multiple`,
            params,
          },
        };
      // 무이자 할부 안내
      case "cardMonthlyFree":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.PAY
            }/api/payment/cardInterestFree/multiple`,
            params: {
              useCache: "CACHE_S10",
              dealSrls: htStorage.htStaticData.sDealNo,
              platform: TMON.bMobile ? "Mobile" : "PC",
            },
          },
        };
      // 쿠폰 요약
      case "couponsSummary":
        // 서버에서 쿠폰API 사용할지를 정해서 내려준다.
        if (TMON.htStaticData.htUseApi.bUseCoupon === false) {
          return null;
        }

        params = {
          useCache: "CACHE_S10",
          useHeader: `AG,CO${TMON.bLogin ? ",MN,AS" : ""}`,
          dealSrls: htStorage.htStaticData.sDealNo,
          timeout: 3000,
          ignore_cache: TMON.currentTimeTimestamp,
        };

        if (htStorage.htStaticData.couponSrl) {
          params.priorityCoupon = htStorage.htStaticData.couponSrl;
        }

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.COUPON
            }/coupons/deals/detail/summary`,
            params,
          },
        };
      // 쿠폰 내용
      case "coupons":
        // 서버에서 쿠폰API 사용할지를 정해서 내려준다.
        if (TMON.htStaticData.htUseApi.bUseCoupon === false) {
          return null;
        }

        params = {
          useCache: "CACHE_S10",
          useHeader: `AG,CO${TMON.bLogin ? ",MN" : ""}`,
          dealSrls: htStorage.htStaticData.sDealNo,
          timeout: 3000,
        };

        if (htStorage.htStaticData.couponSrl) {
          params.priorityCoupon = htStorage.htStaticData.couponSrl;
        }

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.COUPON
            }/coupons/deals/detail/issuable`,
            params,
          },
        };
      // 쿠폰 인터랙션 관련 API - 쿠폰 발급
      case "issueCoupon":
        // coupon type이 그룹일때 그룹번호 , 아닐때 쿠폰번호로 넘긴다.
        const couponType = htParams.type;
        const couponSrl = htParams.couponSrl;
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${ApiBase.COUPON}/account/issue-coupon`,
            params: {
              useParam: "N",
            },
            data: {
              [couponType]: couponSrl,
            },
          },
        };
      // 배송 관련 API
      // 제주/도서산간 지역 목록 조회 - http://deliveryapi.dev.tmon.co.kr/api-helper/node/apis?____param=eJxljz0OwjAMhU/jPbhDxNChSbgCA5tLTRsR5CiBAU5P+FEC6mI9f8/PskEbQDyKnD0XAd0AhWgHaEu7ME2c1jxSokvDiNk7+fal7iwMCrb2LTowr8gnOCe5RXM/+Ghl4po4Uchch7J/NGujVDUizT9GxRTCelM79brsKXkaw/+D2vVPLVQ/MA==#package=com.tmoncorp.delivery.controller&class=DeliveryController&method=getLowAccessibility&apiId=e5cae63e16332fadc1b08220f42adf18
      case "lowAccessibility":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.DELIVERY
            }/api/delivery/low-accessibility`,
            params: {
              all: true,
              groupByZipCode: true,
              page: 1,
              size: 50000,
            },
          },
        };
      case "lowAccessibilityAll":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.DELIVERY
            }/api/delivery/low-accessibility`,
            params: {
              all: true,
              groupByZipCode: false,
              page: 1,
              size: 50000,
            },
          },
        };
      // 대표리뷰 관련 API
      // 대표리뷰
      case "representativeReview":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.DETAIL
            }/api/detail/board/review/represent/${
              htStorage.htStaticData.sDealNo
            }`,
            params: {
              dealType: htStorage.htStaticData.htDealInfo.dealType,
            },
          },
        };
      // 탭 상단 배너 관련 API
      // 마케팅 배너
      case "promotionBannerPC":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${ApiBase.DETAIL}/api/detail/banner/review`,
            data: {
              dealNo: htStorage.htStaticData.sDealNo,
              categoryNos: htStorage.htStaticData.htDealInfo.categoryInfo.categoryNoList.join(
                ","
              ),
            },
          },
        };
      // 상세정보 관련 API
      // 카테고리 공지
      case "announcements":
        const categoryNo = TMON.oApp.oUtil.getMainCategoryNo();
        if (categoryNo <= 0) return null;
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.DEAL_INFO}/api/announcements`,
            params: {
              categoryNo, // 카테고리 번호
              dealNo: htStorage.htStaticData.sDealNo, // 딜 넘버
            },
          },
        };
      // 배송 휴무일 공지
      case "deliveryHolidayNotice":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.DETAIL
            }/api/partner/holiday/notice/current`,
            params: {
              mainDealNo: htStorage.htStaticData.sDealNo,
              partnerNo: htStorage.htStaticData.htDealInfo.partnerNo,
            },
          },
        };
      // 딜별 배너
      case "viewAreaInfoByDealDetail":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.BANNER
            }/api/viewArea/bannerInfo/${this.getPlatformText(
              "PC",
              "MWEB",
              "APP"
            )}/get`, // path param: deviceType: API 호출 client 타입 - PC, MWEB, APP
            params: {
              dealNo: htStorage.htStaticData.sDealNo,
            },
          },
        };
      // 영역 코드로 배너 가져오기
      case "viewAreaInfoByCode":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.BANNER
            }/api/common/viewArea/getByCode`,
            params: {
              viewContentsAreaCode: htParams.viewContentsAreaCode,
            },
          },
        };
      // 연관 딜 목록 - 카테고리 추천 딜, 슈퍼클릭, 본본
      case "intergratedDeals":
        params = {
          verticalType:
            htStorage.htStaticData.htDealInfo.categoryInfo.verticalType[0],
          categoryNo: TMON.oApp.oUtil.getMainCategoryNo(),
          platform: this.getPlatformText(
            "PC_WEB",
            "MOBILE_WEB",
            "",
            "ANDROID",
            "IOS"
          ), // 대상 플랫폼 - PC_WEB, MOBILE_WEB, ANDROID, IOS
          offset: 0,
          limit: 30,
        };

        if (
          htStorage.htStaticData.htDealInfo.deliveryInfo
            .combinedDeliveryPolicyNo
        ) {
          params.combinedDeliveryPolicyNo =
            htStorage.htStaticData.htDealInfo.deliveryInfo.combinedDeliveryPolicyNo;
        }
        if (htStorage.htStaticData.htDealInfo.partnerNo) {
          params.partnerNo = htStorage.htStaticData.htDealInfo.partnerNo;
        }

        return {
          callParam: {
            method: "GET",
            url: `/api/deals/integrated/recommend/${
              htStorage.htStaticData.sDealNo
            }`,
            params,
          },
        };
      // 상세정보 탭 관련 API
      // 구매정보 | 판매자 정보
      case "partnerInfo":
        params = {
          mainDealNo: htStorage.htStaticData.sDealNo,
        };

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.DETAIL}/api/partner/info/${
              htStorage.htStaticData.htDealInfo.partnerNo
            }`,
            params,
          },
        };
      // 구매리뷰 탭 관련 API
      // 포토리뷰 데이터 불러오기
      case "photoReviewList":
        params = {
          offset: htParams.nOffset !== undefined ? htParams.nOffset : 10,
          page: htParams.nPage !== undefined ? htParams.nPage : 1,
          reviewNo: htHash.firstReviewNo ? htHash.firstReviewNo : "",
          useSc: htParams.bShowSCReview, // sc딜 모아보기
          timeout: 5000,
        };

        // [SDLUI-251] 포토리뷰 보는 중 추천하기 등의 이유로 로그인 하고 다시 페이지로 왔을 경우, 보고 있던 리뷰를 라스트의 최상위로 올려서 다시 보여주기 위한 코드
        if (localStorage.getItem("FIRST_REVIEW_ACTION_SERIAL")) {
          params.reviewNo = localStorage.getItem("FIRST_REVIEW_ACTION_SERIAL");
        }

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.BOARD}/api/review/search/list/${
              htStorage.htStaticData.sDealNo
            }`,
            data: {
              useHeader: `${TMON.bLogin ? "MN" : ""}`,
              image: "Y",
            },
            params,
          },
        };
      // 포토리뷰의 이미지 개수 가져오기
      case "photoReviewImageCount":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.BOARD}/api/review/image/count/${
              htStorage.htStaticData.sDealNo
            }`,
            params: {
              flagSc: `${htParams.bShowSCReview ? "Y" : "N"}`, // sc딜 모아보기
              useHeader: `${TMON.bLogin ? "MN" : ""}`,
            },
          },
        };
      // 구매후기·리뷰 가져오기
      case "reviewList":
        params = {
          categoryNo: htStorage.htStaticData.htCategoryInfo.sDepth1No,
          page: 1,
          count: 2,
          useHeader: `${TMON.bLogin ? "MN" : ""}`,
          flagSc: `${htParams.bShowSCReview ? "Y" : "N"}`, // sc딜 모아보기
        };

        if (htParams.page) {
          params.page = htParams.page;
        }
        if (htParams.count) {
          params.count = htParams.count;
          if (htParams.count > 20) params.count = 20;
        }
        if (htParams.optionDealNo) {
          params.optionDealNo = htParams.optionDealNo;
        }
        if (htParams.flagImage) {
          params.flagImage = htParams.flagImage;
        }
        if (htParams.order) {
          params.order = htParams.order;
        }

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.DETAIL
            }/api/detail/board/review/list/${htStorage.htStaticData.sDealNo}`,
            params,
          },
        };
      // 구매후기·리뷰 인터랙션 관련 API
      // 딜 별 구매후기 평가항목 통계
      case "reviewSurveyStatistics":
        params = {
          mainDealNo: htStorage.htStaticData.sDealNo,
        };

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.BOARD
            }/api/review/survey/statistics`,
            data: params,
          },
        };
      // 고정항목 조회
      case "reviewFixSurveyStatistics":
        params = {
          mainDealNo: htStorage.htStaticData.sDealNo,
          fixUse: true,
        };

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.BOARD
            }/api/review/survey/statistics`,
            data: params,
          },
        };
      // 딜 기준 리뷰를 가진 옵션 목록
      case "reviewOptionTree":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.BOARD}/api/review/option/tree/${
              htStorage.htStaticData.sDealNo
            }`,
          },
        };
      // 구매후기·리뷰 삭제
      case "deleteReview":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${ApiBase.BOARD}/api/review/deleteReview/${
              htParams.nMainDealNo
            }/${htParams.nMainBuyNo}/${htParams.nMemberNo}`,
            data: {
              useHeader: "MN",
            },
          },
        };
      // 포토리뷰 추천 (추천취소 가능)
      case "recommendationReview":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${
              ApiBase.BOARD
            }/api/review/recommendation/${htParams.sReviewSrl}`,
            data: {
              useHeader: "MN",
            },
          },
        };
      // 구매후기·리뷰 추천 취소
      case "cancelRecommendationReview":
        return {
          callParam: {
            method: "DELETE",
            url: `${ApiBase.DIRECT}/${
              ApiBase.BOARD
            }/api/review/recommendation/${htParams.sReviewSrl}`,
            data: {
              useHeader: "MN",
            },
          },
        };
      // 구매후기·리뷰 추천
      case "recommendReview":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${ApiBase.BOARD}/api/review/recommend/${
              htParams.sReviewSrl
            }`,
            data: {
              useParam: "S",
            },
          },
        };
      // 구매후기·리뷰 신고
      case "reportReview":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${ApiBase.BOARD}/api/review/report/${
              htParams.sReviewSrl
            }`,
            data: {
              reportReason: htParams.reportType,
              reportContent: htParams.reportUrl,
              partnerYn: "N", // 파트너에 의한 신고 여부
              useParam: "S",
            },
          },
        };
      // 판매자 품질 만족 지수
      case "customerSatisfaction":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.BOARD
            }/api/review/getReviewStats/partner/${
              TMON.htStaticData.htDealInfo.partnerNo
            }`,
          },
        };
      // 상품문의 탭 관련 API
      // 상품문의 목록
      case "qnaList":
        params = {
          page: 1,
          count: 3,
          useHeader: `${TMON.bLogin ? "MN" : ""}`,
          partnerNo: htStorage.htStaticData.htDealInfo.partnerNo
            ? htStorage.htStaticData.htDealInfo.partnerNo
            : "",
        };

        if (htParams.page) {
          params.page = htParams.page;
        }
        if (htParams.count) {
          params.count = htParams.count;
          if (htParams.count > 20) params.count = 20;
        }
        if (htParams.flagSecret) {
          params.flagSecret = htParams.flagSecret;
        }

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.DETAIL
            }/api/detail/board/qna/list/${htStorage.htStaticData.sDealNo}`,
            params,
          },
        };
      // 상품문의 인터랙션 관련 API
      // 상품문의 추가
      case "qnaAdd":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${
              ApiBase.DETAIL
            }/api/detail/board/qna/add/${htStorage.htStaticData.sDealNo}`,
            params: {
              useHeader: "MN",
              content: htParams.content.replace(/\n/g, "<br>"),
              flagSecret: htParams.flagSecret,
              partnerNo: htStorage.htStaticData.htDealInfo.partnerNo
                ? htStorage.htStaticData.htDealInfo.partnerNo
                : "",
            },
          },
        };
      // 상품문의 댓글 추가
      case "qnaAddReply":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${
              ApiBase.DETAIL
            }/api/detail/board/qna/add/reply/${htStorage.htStaticData.sDealNo}`,
            params: {
              useHeader: "MN",
              articleSrl: htParams.articleSrl,
              content: htParams.content.replace(/\n/g, "<br>"),
              flagSecret: htParams.flagSecret,
              partnerNo: htStorage.htStaticData.htDealInfo.partnerNo
                ? htStorage.htStaticData.htDealInfo.partnerNo
                : "",
            },
          },
        };
      // 상품문의 댓글 삭제
      case "qnaDeleteReply":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${ApiBase.BOARD}/api/qna/deleteReply/${
              htParams.replySrl
            }`,
            params: {
              useParam: "MNO",
            },
          },
        };
      // 상품문의 수정
      case "qnaModify":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${
              ApiBase.DETAIL
            }/api/detail/board/qna/modify/${htStorage.htStaticData.sDealNo}`,
            params: {
              articleSrl: htParams.articleSrl,
              useHeader: "MN",
              content: htParams.content.replace(/\n/g, "<br>"),
              partnerNo: htStorage.htStaticData.htDealInfo.partnerNo
                ? htStorage.htStaticData.htDealInfo.partnerNo
                : "",
              flagSecret: htParams.flagSecret,
            },
          },
        };
      // 상품문의 삭제
      case "qnaDelete":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${ApiBase.BOARD}/api/qna/delete/${
              htParams.articleSrl
            }`,
            params: {
              articleSrl: htParams.articleSrl,
              useParam: "MNO",
            },
          },
        };
      // 상품문의 신고
      case "qnaReport":
        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT2}/${
              ApiBase.BOARD
            }/api/qna/report/addReport/${htParams.aSrl}`,
            data: {
              reportReason: htParams.reportType,
              reportContent: htParams.reportUrl,
              useParam: "S",
            },
          },
        };
      // 주문하기/카트 인터랙션 관련 API
      // 구매시 페이코 / 티몬페이 사용 여부
      case "payCustomDeals":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.ORDER}/api/pay/custom`,
            params: {
              mainDealSrls: htStorage.htStaticData.sDealNo,
              limitType: "PAY_METHOD", // 제한 유형 - ANY, PAY_METHOD, COUPON, CART_COUPON
              platform: this.getPlatformText("PC", "M_WEB", "M_APP"), // 대상 플랫폼 - DEFAULT, PC, M_APP, M_WEB
            },
          },
        };
      // 주문하기 마지막 뎁스 선택 시 가져올 옵션 정보 목록
      case "optionList":
        params = {
          categoryNo: htStorage.htStaticData.htCategoryInfo.sDepth1No,
          dealNo: htStorage.htStaticData.sDealNo,
          optionNoList: htParams.aSelectedChildOptionDealSrls.join(","),
          platformType: this.getPlatformText(
            "PC_WEB",
            "MOBILE_WEB",
            "",
            "ANDROID",
            "IOS"
          ), // 플랫폼 - ANDROID(기본값), IOS, PC_WEB, MOBILE_WEB
        };
        // NOTE: 테스트용
        // params.withAll = true;

        if (TMON.util.getCookie("dcn")) {
          params.dcn = TMON.util.getCookie("dcn");
        }
        if (TMON.util.getCookie("ln")) {
          params.ln = TMON.util.getCookie("ln");
        }

        return {
          callParam: {
            method: "POST",
            url: "/api/deals/option/list",
            data: params,
          },
        };
      // 사용자의 카트 개수, 구매 횟수
      case "orderCount":
        params = {
          dealNo: htStorage.htStaticData.sDealNo,
          useHeader: "MN",
        };
        // NOTE: 테스트용
        // params.withAll = true;

        return {
          callParam: {
            method: "GET",
            url: "/api/deals/order/count",
            params,
          },
        };
      // 바로구매 카트 키 받아오기
      case "buyNow":
        return {
          // needLogin: true,
          callParam: {
            method: "POST",
            url: TMON.htLocal.htURL.buyNow.replace(
              /https?:/,
              window.location.protocol
            ),
            dataType: "jsonp",
            data: {
              deal_id: htStorage.htStaticData.sDealNo,
              option_ids: htParams.aOptionDealSrl.join(","),
              counts: htParams.aCount.join(","),
            },
          },
        };
      // 카트 담기
      case "addCartItems":
        return {
          callParam: {
            method: "POST",
            contentType: "application/json",
            url: `${ApiBase.DIRECT}/${
              ApiBase.ORDER
            }/api/cart/tmon/addItems?requestBody=true`,
            params: {
              useHeader: `CO${TMON.bLogin ? ",MN" : ""}`,
              timeout: 5000,
            },
            data: htParams.data,
          },
        };
      // 선물하기
      case "buyGift":
        return {
          callParam: {
            method: "POST",
            contentType: "application/json",
            url: `${ApiBase.DIRECT}/${
              ApiBase.ORDER
            }/api/buy/direct/?requestBody=true`,
            params: {
              useHeader: `AG${TMON.bLogin ? ",MN" : ""}`,
            },
            data: htParams.data,
          },
        };
      // 찜하기 인터랙션 관련 api
      // 찜 관련 정보: 딜별 찜 횟수, 사용자의 찜하기 여부
      case "getDibsInfo":
        if (TMON.bLogin) {
          return {
            callParam: {
              method: "GET",
              url: `${ApiBase.DIRECT}/${ApiBase.DEALSVC}/api/dibs/${
                htParams.dibsType === "PARTNER" ? partnerNo : dealNo
              }`,
              params: {
                useHeader: `${TMON.bLogin ? "MN" : ""}`,
                contentId: htParams.dibsType === "PARTNER" ? partnerNo : dealNo,
                dibsType: htParams.dibsType || "DEAL",
              },
            },
          };
        }

        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.DEALSVC}/api/dibs/${
              htParams.dibsType === "PARTNER" ? partnerNo : dealNo
            }/count`,
            params: {
              contentId: htParams.dibsType === "PARTNER" ? partnerNo : dealNo,
              dibsType: htParams.dibsType || "DEAL",
            },
          },
        };
      // 찜하기 추가(찜하기는 공통 컴포넌트에서 정보만 받아쓰므로 DELETE도 POST정보로 사용)
      case "postDibsInfo":
        return {
          needLogin: true,
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${ApiBase.DEALSVC}/api/dibs/${
              htParams.dibsType === "PARTNER" ? partnerNo : dealNo
            }`,
            params: {
              useHeader: "MN",
            },
            data: {
              contentId: htParams.dibsType === "PARTNER" ? partnerNo : dealNo,
              dibsType: htParams.dibsType || "DEAL",
              dealSrl: dealNo,
            },
          },
        };
      // logging 관련 API
      // clickLog
      case "statisticsClick":
        if (TMON.htStaticData.htUseApi.bUseStaticClickLog === false) {
          return null;
        }

        params = {
          areaCode: htParams.areaCode ? htParams.areaCode : "",
          link: htParams.link ? htParams.link : "",
          linkOrder: htParams.linkOrder ? htParams.linkOrder : "",
          label: htParams.label ? htParams.label : "",
          statisticsAdditionalInfo: htParams.statisticsAdditionalInfo
            ? htParams.statisticsAdditionalInfo
            : {},
          mainDealNo: dealNo,
          currentTime: new Date().getTime(),
          pId: window.tl_vars ? window.tl_vars.p_id : "",
          sId: window.tl_vars ? window.tl_vars.s_id : "",
          href: window.location.href,
          referrer: document.referrer,
          detailABTestInfo: htStorage.htStaticData.detailABTestInfoJson,
          categoryInfo: htStorage.htStaticData.htDealInfo.categoryInfo,
          additionalInfo: htStorage.htStaticData.htDealInfo.additionalInfo,
          dealType: htStorage.htStaticData.htDealInfo.dealType,
          verticalType:
            htStorage.htStaticData.htDealInfo.categoryInfo.verticalType[0],
          productType: htStorage.htStaticData.htDealInfo.productType,
          mainCategoryNo: TMON.oApp.oUtil.getMainCategoryNo(),
          titleName: htStorage.htStaticData.htDealInfo.titleName,
          deployPhase: TMON.sDeployPhase,
          platformType: this.getPlatformText(
            "PC",
            "MOBILE",
            "",
            "ANDROID",
            "IOS"
          ), // 플랫폼 - ANDROID(기본값), IOS, PC_WEB, MOBILE_WEB
        };

        return {
          callParam: {
            method: "POST",
            contentType: "application/json",
            url: `${ApiBase.DIRECT}/${ApiBase.DETAIL}/api/statistics/click`,
            data: JSON.stringify(params),
            params: {
              useHeader: `IP${TMON.bLogin ? ",MN" : ""}`,
            },
          },
        };
      // eslog에 보낼 에러 로그
      case "sendError":
        if (!htParams.htErrorInfo) {
          params = {
            htErrorInfo: {},
          };
        } else {
          params = htParams;
        }

        return {
          callParam: {
            method: "POST",
            // url: `${TMON.htLocal.htURL.stash}/api/report/web/js`,
            url: `${ApiBase.DIRECT}/${ApiBase.STASH}/api/report/web/js`,
            data: {
              body: JSON.stringify(params),
            },
          },
        };
      case "sendTrackerApi":
        params = htParams;
        params.log = [];

        return {
          callParam: {
            method: "POST",
            url: `${ApiBase.DIRECT}/${ApiBase.STASH}/api/report/web/js`,
            data: {
              useHeader: `${TMON.bLogin ? "AG,MN" : ""}`,
              body: JSON.stringify(params),
              logOption: "ES",
              serviceName: "service-tmon-ui-traker",
              esType: "SCRIPT_ERROR",
              url: window.location.href,
            },
          },
        };
      // 회원 메일 수신 동의 조회
      case "getEmailOptIn":
        return {
          needLogin: true,
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.MEMBER
            }/api/members/member/email/agree`,
            data: {
              useHeader: `${TMON.bLogin ? "MN" : ""}`,
            },
          },
        };
      // 회원 메일 수신 동의 수정
      case "putEmailOptIn":
        return {
          needLogin: true,
          callParam: {
            method: "PUT",
            url: `${ApiBase.DIRECT}/${
              ApiBase.MEMBER
            }/api/members/member/email/agree`,
            data: {
              useHeader: `${TMON.bLogin ? "MN" : ""}`,
            },
          },
        };
      case "identicalProduct":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.SEARCH2}/api/category/priceList`,
            data: {
              categoryNo: TMON.oApp.oUtil.getMainCategoryNo(true),
              platformType: this.getPlatformText(
                "PC_WEB",
                "MOBILE_WEB",
                "",
                "ANDROID",
                "IOS"
              ), // 플랫폼 - ANDROID(기본값), IOS, PC_WEB, MOBILE_WEB,
              sort: "PRICE_DELIVERY",
              order: "ASC",
              size: 5,
              mainDealOnly: true,
            },
          },
        };
      case "subscriptionConfirm":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.SUBS}/api/subs/issubsdeal`,
            params: {
              mNo: htParams.mNo,
              dealNo: htParams.dealNo,
            },
          },
          htParams: {
            ...htParams,
          },
        };
      case "d2cInfo":
        if (!TMON.htStaticData.htDealInfo.isChnlDeal) return null;
        return {
          callParam: {
            method: "GET",
            url: `${TMON.htLocal.htURL.tgate}/channelhome/deal/chnlinfo`,
            params: {
              partnerNo: TMON.htStaticData.htDealInfo.partnerNo,
            },
          },
        };
      case "cpc":
        const pId = window.tl_vars ? window.tl_vars.p_id : "";
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.BRIDGE}/api/admon/cpc/log`,
            params: {
              logType: htParams.logType,
              pid: pId,
              x: htParams.x,
            },
          },
        };
      case "adDealList":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${ApiBase.DEALSVC}/api/deals/ai/ad/infos`,
            params: {
              adRequestPageType: "DETAIL_CART",
              keyword: TMON.oApp.oUtil.getMainCategoryNo(),
              platformType: this.getPlatformText(
                "PC",
                "MOBILE_WEB",
                "",
                "ANDROID",
                "IOS"
              ), // 대상 플랫폼 - PC_WEB, MOBILE_WEB, ANDROID, IOS
            },
          },
        };
      case "viewAreaGetByDealNo":
        return {
          callParam: {
            method: "GET",
            url: `${ApiBase.DIRECT}/${
              ApiBase.BANNER
            }/api/common/viewArea/getByDealNo`,
            params: {
              dealNo: htStorage.htStaticData.sDealNo,
            }
          }
        };
      default:
        return null;
    }
  }

  /**
   * param에 의해 api를 호출하여 storage에 저장
   * @param sApiName 호출할 api명
   * @param htParams 호출할 api에 추가할 파라미터 정보(getApiInfo()에 전달)
   * @param actionType 호출할 api의 redux action type
   */
  async fetchApi(sApiName, htParams = {}, actionType = "") {
    try {
      const htApiInfo = this.getApiInfo(sApiName, htParams);

      // api 정보가 없거나, 로그인이 필요한 api이지만 로그인이 되어있지 않을 경우
      if (!htApiInfo || (htApiInfo.needLogin && !TMON.bLogin)) return;

      if (sApiName === "optionTree") {
        if (!TMON.htStaticData.isSale && !TMON.htStaticData.isBeforeOpen)
          return;
      }

      if (!htApiInfo.callParam.params) {
        htApiInfo.callParam.params = {};
      }

      const htAjaxParam = {
        url: TMON.util.aup(htApiInfo.callParam.url, htApiInfo.callParam.params),
        method: htApiInfo.callParam.method,
        data: htApiInfo.callParam.data,
        success: (res, _, xhr) => {
          function getResponse() {
            if (typeof res === "object") return { ...res };
            else return { data: { ...res } };
          }

          let oError;
          try {
            const htResponse = getResponse();

            if (htApiInfo.callParam) {
              htResponse.callParam = htApiInfo.callParam;
            }
            htResponse.htParams = htParams;

            TMON.oApp.setStorage(sApiName, htResponse);

            this.disPatchStore({
              bSuccess: true,
              actionType,
              sApiName,
              htResponse,
            });
          } catch (e) {
            oError = e;
            console.error("fetchApi success error", e);
            this.disPatchStore({
              bSuccess: false,
              actionType,
              sApiName,
              e,
            });
          } finally {
            if (sApiName !== "sendError" && res && xhr.status !== 200) {
              TMON.oApp.errorHandler({
                from: `${sApiName} : fetchApi success callback, res`,
                value: res,
                bLoggingEslog: true,
              });
            } else if (sApiName !== "sendError" && oError) {
              TMON.oApp.errorHandler({
                from: `${sApiName} : fetchApi success callback, error`,
                value: oError,
              });
            }
          }
        },
        error: (res) => {
          let oError = {};
          try {
            const { isSecondCall } = TMON.util.getHashJSON();
            const htResponse = {
              httpCode: res.status,
              httpStatus: res.statusText,
              responseJSON: res.responseJSON,
              data: res.responseJSON,
            };
            if (htApiInfo.callParam) {
              htResponse.callParam = htApiInfo.callParam;
            }
            if (htApiInfo.htParams) {
              htResponse.htParams = htApiInfo.htParams;
            }
            if (
              res &&
              res.responseJSON &&
              res.responseJSON.exceptionCode === "DIRECT_LOGIN_FAIL" &&
              isSecondCall === "Y"
            ) {
              TMON.bLogin = false;
              TMON.util.removeHash("isSecondCall");
              localStorage.removeItem("AFTER_LOGIN_BENEFIT");
              localStorage.removeItem("AFTER_LOGIN_QNA");
              localStorage.removeItem("AFTER_LOGIN_REVIEW");
              window.location.reload();
              return;
            }
            if (
              res &&
              res.responseJSON &&
              res.responseJSON.exceptionCode === "DIRECT_LOGIN_FAIL" &&
              TMON.bLogin === true &&
              sApiName !== "addCartItems"
            ) {
              TMON.util.setHashJSON({ isSecondCall: "Y" });
              TMON.bLogin = false;
              alert(
                "로그인이 필요한 서비스입니다.\n로그인 후에 다시 시도해 주십시오."
              );
              TMON.oApp.oUtil.login(window.location.href, "", true);
              return;
            }
            TMON.oApp.setStorage(sApiName, htResponse);
            this.disPatchStore({
              bSuccess: false,
              actionType,
              sApiName,
              e: htResponse,
            });
          } catch (e) {
            oError = e;
            console.error("fetchApi fail error", e);
            this.disPatchStore({
              bSuccess: false,
              actionType,
              sApiName,
              e,
            });
          } finally {
            if (sApiName !== "sendError") {
              TMON.oApp.errorHandler({
                from: `${sApiName} : fetchApi error callback, res`,
                value: {
                  res,
                  error: oError,
                },
                bLoggingEslog: true,
              });
            }
          }
        },
      };

      if (htApiInfo.callParam.dataType) {
        htAjaxParam.dataType = htApiInfo.callParam.dataType;
      }

      if (htApiInfo.callParam.contentType) {
        htAjaxParam.contentType = htApiInfo.callParam.contentType;
      }

      switch (actionType) {
        case "default":
          store.dispatch(defaultActionCreators.fetchDefault());
          break;
        case "fetchApi":
          store.dispatch(fetchApiActionCreators.fetchApi());
          break;
        default:
          break;
      }

      // async/await 사용가능하게 변경
      await $.ajax(htAjaxParam);
    } catch (e) {
      TMON.oApp.errorHandler({ error: e });
      console.error(e);
    }
  }

  /**
   * API Action Type에 따라 store action dispatch
   * @param bSuccess
   * @param actionType
   * @param sApiName
   * @param htResponse
   * @param
   */
  disPatchStore({ bSuccess, actionType, sApiName, htResponse, e }) {
    if (bSuccess) {
      switch (actionType) {
        case "default":
          store.dispatch(
            defaultActionCreators.fetchDefaultFulfilled({
              apiName: sApiName,
              apiResponse: htResponse,
            })
          );
          break;
        case "fetchApi":
          store.dispatch(
            fetchApiActionCreators.fetchApiFulfilled({
              apiName: sApiName,
              apiResponse: htResponse,
            })
          );
          break;
        default:
          break;
      }
    } else {
      switch (actionType) {
        case "default":
          store.dispatch(
            defaultActionCreators.fetchDefaultRejected({
              apiName: sApiName,
              error: e,
            })
          );
          break;
        case "fetchApi":
          store.dispatch(
            fetchApiActionCreators.fetchApiRejected({
              apiName: sApiName,
              error: e,
            })
          );
          break;
        default:
          break;
      }
    }
  }

  /**
   * 사용자가 접속한 client의 플랫폼에 적절한 플랫폼 문자열을 반환
   * @param {string} pcWeb
   * @param {string} mWeb
   * @param {string} mApp
   * @param {string} android
   * @param {string} ios
   * @param {string} defaultValue
   * @returns {string} 위의 param중 가장 적절한 값을 반환
   */
  getPlatformText(pcWeb, mWeb, mApp, android, ios, defaultValue = null) {
    if (defaultValue) {
      return defaultValue;
    }

    if (!TMON.bMobile) {
      return pcWeb;
    }

    if (TMON.view_mode === "web") {
      return mWeb;
    }

    if (TMON.view_mode === "app") {
      if (android && (TMON.app_os === "android" || TMON.app_os === "ad")) {
        return android;
      }

      if (ios && TMON.app_os === "ios") {
        return ios;
      }

      return mApp;
    }

    return "";
  }
}
